function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMathsicon = function SvgMathsicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m62.6 55.5 16.7 19c.6.9.6 1.9 0 2.7l-17 19.2h27.8c1.7 0 1.1-2.9 1.1-4s.2-1.6.3-1.9c.8-1.7 3.8-1.3 4.2.5s0 4.5-.1 5.7c-.4 2.1-1.5 3.8-3.8 4.1s-6.5 0-9.2 0c-7.9 0-15.9.2-23.8 0s-2.6.3-3.4-.8-.6-1.6-.2-2.3l19.2-21.8-18.7-21.5c-.8-1.5.1-3.2 1.8-3.3H92c2.1.5 3.5 1.6 3.9 3.8s.4 4 .1 5-2.2 1.9-3.4 1.1c-2-1.3-.5-4.5-1.5-5.2s-.9-.3-.9-.3H62.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "props.color",
    d: "M23.2 62.4v14.5c3-3.1 5.9-9.3 11-7.7s4 3 5.1 5 1.6 2.9 1.7 3.3c0 .7-1 2-1.6 1.5-1.1-1.9-2-4.1-3.5-5.8-5.2-5.6-9.2 4.3-12.6 7.1v1.9c.3.2.3.4.5.6s.4.3.5.3h15c-.2-.8-.1-1.8.9-1.5s3.3 1.6 3.5 1.8c.5.5.2.7-.4 1.2s-2.9 1.9-3.1 1.9c-1 .2-1-.9-.8-1.6H24.1l-.5.5c-.1.1-.2.3-.3.4-.2.7-2.2.8-2.4 0l-.8-.8H6.5c-1.2-.1-1.3-1.6 0-1.8h13.8c0-.4.7-.7.8-.9.1-.4.1-1.3.1-1.3s-1.6.7-2.5.8c-4.8.5-7.8-5.4-9.5-9.1s-2.4-5-2.7-6.6.2-2 1.7-1.6c1.1 2.9 2.3 5.2 3.7 7.9 1.9 3.4 4.9 8.9 9.2 5.5.3-5.4 0-10.1.2-15.6-.8 0-2 0-1.8-1.1l2.1-3.3c.4-.4.8-.3 1.1 0s2 3 2.1 3.2c.2 1.1-1.4 1.1-1.4 1.1ZM58.6 121s.2-.2.3-.2l41.1.3c.7.1 1.1.9.6 1.5l-28.2 18.7c-.4.2-.8.3-1.2 0L58.4 122c-.1-.3 0-.7.2-1Zm3.8 2.2 6.4 10 .4.2 4.3-2.8c.2-.1.7 0 .8.1l2.9 4.2 17.6-11.4zm10.7 10.6s-2.8 1.8-2.8 1.9l1.6 2.4 2.9-1.7-1.8-2.6Z",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: ".4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.5 22.2c1.2-.3 3.3 1.4 4.3 2.1 6.2 4.3 11.9 10.6 15.9 17 18.4 29.1 9.8 67.6-19.1 86-1 .6-3.6 2.4-4.6 2.7-1.6.4-2.8-1.3-1.8-2.6s2.5-1.5 3.3-2c14.8-9.2 24.8-23.5 27.7-40.8 3.9-23.3-6.5-47.2-26.6-59.6-.7-.9-.3-2.4.8-2.7Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "6.4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "props.color",
    d: "m82.8 11.6-7.4 23.2c-.4 1.1-1.8 1.3-2.7.6l-5.6-13.7c-.3-.2-3.5.1-4.3 0-1.4-.4-1.4-2.8.6-3s3.8-.1 4.8 0 .8.2 1.1.5l4.5 10.7 6.3-20.3c.2-.4.5-.7 1-.9h15.1c1.7.5 1.5 2.7-.2 3H82.8Z",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: ".4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "props.color",
    d: "M124.4 59.6c1.5-.2 3.1.4 3.7 1.8s0 2.6-1.5 2.3-.5-1.8-1.7-1.7c-1.9 0-2.4 3.2-2.6 4.7-.7 5.8-.8 11.9-1.4 17.7-.3 2.5-.6 5.8-2.8 7.4s-5.3.7-5.6-2 .5-2.2 1.8-1.8.2 2.1 1.6 2 2.3-4.1 2.4-5.5c.6-5.3.7-10.7 1.2-16.1s.8-8.3 4.8-8.8Z",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: ".3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 103.3c4.7 8.3 11 15 18.9 20.3s2.8 1.4 3 2.3c.4 1.4-.9 2.4-2.3 2s-3.6-2.2-4.7-2.9c-6.3-4.4-12.3-10.8-16.4-17.4s-1.7-2.5-1.5-3.3c.3-1.4 1.9-1.8 2.9-.9ZM40.8 25.1c-8.3 4.7-15 11-20.3 18.9s-1.4 2.8-2.3 3c-1.4.4-2.4-.9-2-2.3s2.2-3.6 2.9-4.7c4.4-6.3 10.8-12.3 17.4-16.4.8-.5 2.5-1.7 3.3-1.5 1.4.3 1.8 1.9.9 2.9Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "6.4px"
    }
  }));
};
export default SvgMathsicon;